var React = require('react');

function File (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M5.625 1.5C4.589 1.5 3.75 2.34 3.75 3.375V20.625C3.75 21.66 4.59 22.5 5.625 22.5H18.375C19.41 22.5 20.25 21.66 20.25 20.625V12.75C20.25 11.7554 19.8549 10.8016 19.1517 10.0983C18.4484 9.39509 17.4946 9 16.5 9H14.625C14.1277 9 13.6508 8.80246 13.2992 8.45083C12.9475 8.0992 12.75 7.62228 12.75 7.125V5.25C12.75 4.25544 12.3549 3.30161 11.6517 2.59835C10.9484 1.89509 9.99456 1.5 9 1.5H5.625Z","fill":"white","key":0}),React.createElement("path",{"d":"M12.9707 1.81592C13.7972 2.76888 14.2515 3.98846 14.2497 5.24992V7.12492C14.2497 7.33192 14.4177 7.49992 14.6247 7.49992H16.4997C17.7612 7.49817 18.9807 7.9524 19.9337 8.77892C19.4937 7.10563 18.6172 5.57922 17.3938 4.3558C16.1704 3.13239 14.644 2.25588 12.9707 1.81592Z","fill":"white","key":1})]);
}

File.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = File;

File.default = File;
